import React, { useState } from 'react';
import { useData } from "../../../components/context/DataContext";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, EffectFlip, EffectFade, Pagination, Scrollbar, A11y } from 'swiper/modules';
import { useModuleIndex, useScreenIndex, useScreenIndexUpdate } from "../../../components/context/ModuleContext";
import { useScreenType, useScreenTypeUpdate, useSwipers, useSwipersUpdate } from "../../../components/context/MixContext";
import { useScreenShowUpdate } from "../../../components/context/ScreenContext";

import { Virtual } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/virtual';
import 'swiper/css/effect-flip';
import 'swiper/css/effect-fade';

import '../Slides.css'

import CNSSlide00 from "../../../layout/Slides/CNS/Slide00";
import CNSSlide01 from "../../../layout/Slides/CNS/Slide01";
import CNSSlide02 from "../../../layout/Slides/CNS/Slide02";
import CNSSlide03 from "../../../layout/Slides/CNS/Slide03";
import CNSSlide04 from "../../../layout/Slides/CNS/Slide04";
import CNSSlide05 from "../../../layout/Slides/CNS/Slide05";
import CNSSlide06 from "../../../layout/Slides/CNS/Slide06";
import CNSSlide07 from "../../../layout/Slides/CNS/Slide07";
import CNSSlide08 from "../../../layout/Slides/CNS/Slide08";
import CNSSlide09 from "../../../layout/Slides/CNS/Slide09";
import CNSSlide10 from "../../../layout/Slides/CNS/Slide10";

const CNSSlideHolder = () => {

    // Screen show
    const setScreenShow = useScreenShowUpdate();

    // data
    const json = useData();

    // module index
    const getModuleIndex = useModuleIndex();
    const setModuleIndex = useScreenIndexUpdate();

    // currentIndex
    let [currentIndex, setCurrentIndex] = useState(0)

    // screen type
    const getScreenType = useScreenType();
    const setScreenType = useScreenTypeUpdate();

    // screen index
    const getScreenIndex = useScreenIndex();
    const setScreenIndex = useScreenIndexUpdate();

    // swipers
    const getSwipers = useSwipers();
    const setSwipers = useSwipersUpdate();

    const prevSlidePlease = (_swipe) => {
        const idx = currentIndex;
        setCurrentIndex(idx-1);
        checkNav(_swipe, false, idx-1);
    }
    const nextSlidePlease = (_swipe) => {
        const idx = currentIndex;
        setCurrentIndex(idx+1);
        checkNav(_swipe, true, idx+1);
    }

    const checkNav = (_swiper, _next, _idx) => {
        if ( _next ) {
            if ( currentIndex === _swiper.slides.length-1 ) {
                setScreenShow(true);
            } else {
                _swiper.slideNext();
                const info = document.getElementById("slide-data");
                info.innerHTML = json && json.screen[getModuleIndex].data[_idx][0].txt;
                setScreenIndex(_idx);
            }
        } else {
            if ( currentIndex === 0 ) {
                setScreenShow(true);
            } else {
                _swiper.slidePrev();
                const info = document.getElementById("slide-data");
                info.innerHTML = json && json.screen[getModuleIndex].data[_idx][0].txt;
                setScreenIndex(_idx);
            }
        }
    }

    return (
        <Swiper
            observer={true}
            observeParents={true}
            autoHeight= {true}
            modules={[Navigation, EffectFade, EffectFlip, A11y, Virtual]}
            spaceBetween={2}
            slidesPerView={1}
            noSwiping={true}  
            noSwipingClass='noswiper'
            centeredSlides
            onSlideChange={(swiper) => {
                //  
            }}
            onAfterInit={(swiper) => {
                swiper.slideTo(getScreenIndex, .2);
                setCurrentIndex(getScreenIndex);
                setScreenIndex(getScreenIndex);
                const info = document.getElementById("slide-data");
                info.innerHTML = json && json.screen[getModuleIndex].data[getScreenIndex][0].txt;
            }}
            onBeforeSlideChangeStart={(swiper) => {
                // 
            }}
            onSlideChangeTransitionEnd={(swiper) => {
                
            }}
            onReachEnd={(swiper) => {
                // console.log("reach end");
            }}
        >
            <SwiperSlide className="noswiper" key={0} virtualIndex={0}>
                <CNSSlide00 slideprevplease={prevSlidePlease} slidenextplease={nextSlidePlease} mod="0" screen="0" data={json && json.screen[getModuleIndex].data[0][0]} />
            </SwiperSlide>
            <SwiperSlide className="noswiper" key={1} virtualIndex={1}>
                <CNSSlide01 slideprevplease={prevSlidePlease} slidenextplease={nextSlidePlease} mod="0" screen="1" data={json && json.screen[getModuleIndex].data[1][0]} />
            </SwiperSlide>
            <SwiperSlide className="noswiper" key={2} virtualIndex={2}>
                <CNSSlide02 slideprevplease={prevSlidePlease} slidenextplease={nextSlidePlease} mod="0" screen="2" data={json && json.screen[getModuleIndex].data[2][0]} />
            </SwiperSlide>
            <SwiperSlide className="noswiper" key={3} virtualIndex={3}>
                <CNSSlide03 slideprevplease={prevSlidePlease} slidenextplease={nextSlidePlease} mod="0" screen="3" data={json && json.screen[getModuleIndex].data[3][0]} />
            </SwiperSlide>
            <SwiperSlide className="noswiper" key={4} virtualIndex={4}>
                <CNSSlide04 slideprevplease={prevSlidePlease} slidenextplease={nextSlidePlease} mod="0" screen="4" data={json && json.screen[getModuleIndex].data[4][0]} />
            </SwiperSlide>
            <SwiperSlide className="noswiper" key={5} virtualIndex={5}>
                <CNSSlide05 slideprevplease={prevSlidePlease} slidenextplease={nextSlidePlease} mod="0" screen="5" data={json && json.screen[getModuleIndex].data[5][0]} />
            </SwiperSlide>
            <SwiperSlide className="noswiper" key={6} virtualIndex={6}>
                <CNSSlide06 slideprevplease={prevSlidePlease} slidenextplease={nextSlidePlease} mod="0" screen="6" data={json && json.screen[getModuleIndex].data[6][0]} />
            </SwiperSlide>
            <SwiperSlide className="noswiper" key={7} virtualIndex={7}>
                <CNSSlide07 slideprevplease={prevSlidePlease} slidenextplease={nextSlidePlease} mod="0" screen="7" data={json && json.screen[getModuleIndex].data[7][0]} />
            </SwiperSlide>
            <SwiperSlide className="noswiper" key={8} virtualIndex={8}>
                <CNSSlide08 slideprevplease={prevSlidePlease} slidenextplease={nextSlidePlease} mod="0" screen="8" data={json && json.screen[getModuleIndex].data[8][0]} />
            </SwiperSlide>
            <SwiperSlide className="noswiper" key={9} virtualIndex={9}>
                <CNSSlide09 slideprevplease={prevSlidePlease} slidenextplease={nextSlidePlease} mod="0" screen="9" data={json && json.screen[getModuleIndex].data[9][0]} />
            </SwiperSlide>
            <SwiperSlide className="noswiper" key={10} virtualIndex={10}>
                <CNSSlide10 slideprevplease={prevSlidePlease} slidenextplease={nextSlidePlease} mod="0" screen="10" data={json && json.screen[getModuleIndex].data[10][0]} />
            </SwiperSlide>
        </Swiper>
    );
};

export default CNSSlideHolder;